export default "__VITE_PUBLIC_ASSET__b857205d__"